import http from "../../http-common";
export default class HubspotUpdateSubscription {
  postPreferenceSubscriptions(userId: string, subscriptionField: { subscriptionId: number, statusState: string}[]) {
    let url = `/hubspot/subscriptions/${userId}`;

    return http.post(url, subscriptionField);
  }
}